import { render, staticRenderFns } from "./GalleryCarousel.vue?vue&type=template&id=5e845764&scoped=true"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js"
import style0 from "./GalleryCarousel.vue?vue&type=style&index=0&id=5e845764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e845764",
  null
  
)

export default component.exports